import { render, staticRenderFns } from "./phoneCode.vue?vue&type=template&id=00e454d8&scoped=true"
import script from "./phoneCode.vue?vue&type=script&lang=js"
export * from "./phoneCode.vue?vue&type=script&lang=js"
import style0 from "./phoneCode.vue?vue&type=style&index=0&id=00e454d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e454d8",
  null
  
)

export default component.exports